import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/file-types/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/file-types/delete`,
        endpoint: `${endpointBackend}gci/file-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Arquivos',
        labelTitleButtonAdd: 'Incluir novo tipo de arquivo',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Tipo de Arquivo',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
